import React from 'react';
import InfiniteList from './items/InfiniteList';
import TextRow from './items/TextRow';
export default function DescriptiveTableWidget(props) {
    return (React.createElement(InfiniteList, { data: props.data, handleSelected: props.handleSelected, componentType: TextRow, rowHeight: 80 }));
}
